import { render, staticRenderFns } from "./RegionById.vue?vue&type=template&id=95898c9a"
import script from "./RegionById.vue?vue&type=script&lang=js"
export * from "./RegionById.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports